// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { backend_url } from "./clientUrl";
// import { AiOutlineCheckCircle, AiOutlineCopy } from "react-icons/ai";
// import { TbTruckDelivery } from "react-icons/tb";
// import { useAuth } from "./AuthContext";

// const Success = () => {
               
//               //  const {Useraddress,UserselectedProduct} = useAuth()
//   const location = useLocation();
//   const navigate = useNavigate();
// //   const { product, address } = location.state || {};
//   const [trackingId, setTrackingId] = useState("");
//   const [expectedDate, setExpectedDate] = useState("");
//   const [copySuccess, setCopySuccess] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");
//   const {Useraddress,UserselectedProduct} = useAuth()
  
//   useEffect(() => {
//     console.log('Useraddress:', Useraddress);
//     console.log('UserselectedProduct:', UserselectedProduct);
//   }, [Useraddress, UserselectedProduct]);

//   // Redirect if product or address is missing
// //   useEffect(() => {
// //     if (!product || !address) {
// //       setErrorMessage("Invalid order details! Redirecting...");
// //       setTimeout(() => navigate("/catalogue"), 3000); // Redirect after 3 seconds
// //     }
// //   }, [product, address, navigate]);

//   // Send order to backend and get tracking details from Shiprocket
//   // useEffect(() => {
//   //   const sendOrderToShiprocket = async () => {
//   //     const token = localStorage.getItem("accessToken");
//   //     if (!token) {
//   //       setErrorMessage("User is not logged in. Please log in again.");
//   //       return;
//   //     }

//   //     try {
//   //       const response = await axios.post(
//   //         `${backend_url}/auth/order`,
//   //         {
//   //           address,
//   //           product: ,
//   //           amount: selectedProduct.price,
//   //         },
//   //         {
//   //           headers: {
//   //             "Content-Type": "application/json",
//   //             Authorization: `Bearer ${token}`,
//   //           },
//   //         }
//   //       );

//   //       if (response.status === 200) {
//   //         const data = response.data;
//   //         setTrackingId(data.tracking_id);
//   //         setExpectedDate(data.expected_delivery_date);
//   //       } else {
//   //         setErrorMessage("Failed to place order.");
//   //       }
//   //     } catch (error) {
//   //       console.error("Error placing order:", error);
//   //       setErrorMessage("Order placement failed. Please try again.");
//   //     }
//   //   };

//   //   if (selectedProduct && address) {
//   //     sendOrderToShiprocket();
//   //   }
//   // }, [selectedProduct, address]);

//   // const copyToClipboard = () => {
//   //   navigator.clipboard.writeText(trackingId);
//   //   setCopySuccess(true);
//   //   setTimeout(() => setCopySuccess(false), 3000); // Hide copy success message after 3 seconds
//   // };

//   return (
//     // <div className="min-h-screen flex items-center justify-center bg-gray-100">
//     //   <div className="max-w-lg w-full bg-white shadow-md rounded-lg p-8 text-center relative">
//     //     {errorMessage && (
//     //       <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-red-500 text-white px-4 py-2 rounded-md">
//     //         {errorMessage}
//     //       </div>
//     //     )}

//     //     <h1>Order Successful!</h1>
//     //         {user && <p>Thank you, {user.name}!</p>}
//     //         {selectedProduct && (
//     //             <div>
//     //                 <h2>Product Details</h2>
//     //                 <p>Name: {selectedProduct.name}</p>
//     //                 <p>Price: ${selectedProduct.price}</p>
//     //             </div>
//     //         )}
//     //         {address && (
//     //             <div>
//     //                 <h2>Shipping Address</h2>
//     //                 <p>{address.street}</p>
//     //                 <p>{address.city}, {address.state} {address.pincode}</p>
//     //             </div>
//     //         )}
//     //     <AiOutlineCheckCircle className="text-green-500 mx-auto text-6xl mb-4" />
//     //     <h1 className="text-3xl font-semibold mb-4">Payment Successful!</h1>
//     //     <p className="text-lg mb-2">Thank you for your order.</p>

//     //     <div className="text-gray-600 mb-4">
//     //       <p>Your tracking ID is:</p>
//     //       <span className="font-semibold">{trackingId || "Fetching..."}</span>
//     //     </div>

//     //     <p className="text-gray-600 mb-6">
//     //       Expected Delivery: <span className="font-semibold">{expectedDate || "Fetching..."}</span>
//     //     </p>

//     //     <div className="flex justify-center gap-4">
//     //       <button
//     //         onClick={copyToClipboard}
//     //         className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 flex items-center gap-2"
//     //       >
//     //         <AiOutlineCopy className="text-lg" />
//     //         Copy Tracking ID
//     //       </button>
//     //       <a
//     //         href={`https://shiprocket.co/tracking/${trackingId}`}
//     //         target="_blank"
//     //         rel="noopener noreferrer"
//     //         className={`bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 flex items-center gap-2 ${
//     //           !trackingId ? "opacity-50 cursor-not-allowed" : ""
//     //         }`}
//     //       >
//     //         <TbTruckDelivery className="text-lg" />
//     //         Track Order
//     //       </a>
//     //     </div>

//     //     {copySuccess && (
//     //       <p className="mt-4 text-green-500">Tracking ID copied to clipboard!</p>
//     //     )}
//     //   </div>
//     // </div>
//     <div>Success Page</div>
//   );
// };

// export default Success;
 import React, { useEffect, useState } from "react";
import { useAuth } from './AuthContext'

import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { backend_url } from "./clientUrl";
import { AiOutlineCheckCircle, AiOutlineCopy } from "react-icons/ai";
import { TbTruckDelivery } from "react-icons/tb";
import Navbar from "./Navbar";

export const Success = () => {
  const navigate = useNavigate();
  const [trackingId, setTrackingId] = useState("");
  const [expectedDate, setExpectedDate] = useState("");
  const [copySuccess, setCopySuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const {Useraddress,UserselectedProduct} = useAuth()
  
  useEffect(() => {
    console.log('Useraddress:', Useraddress);
    console.log('UserselectedProduct:', UserselectedProduct);
  }, [Useraddress, UserselectedProduct]);

  // Redirect if product or address is missing
//   useEffect(() => {
//     if (!product || !address) {
//       setErrorMessage("Invalid order details! Redirecting...");
//       setTimeout(() => navigate("/catalogue"), 3000); // Redirect after 3 seconds
//     }
//   }, [product, address, navigate]);

  useEffect(() => {
    const sendOrderToShiprocket = async () => {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        setErrorMessage("User is not logged in. Please log in again.");
        return;
      }

      try {
        const response = await axios.post(
          `${backend_url}/auth/order`,
          {
            address:Useraddress,
            product: UserselectedProduct,
            amount: UserselectedProduct.price,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          const data = response.data;
          setTrackingId(data.order.tracking_id);
          setExpectedDate(data.expected_delivery_date);
        } else {
          setErrorMessage("Failed to place order.");
        }
      } catch (error) {
        console.error("Error placing order:", error);
        setErrorMessage("Order placement failed. Please try again.");
      }
    };

    if (Useraddress) {
      sendOrderToShiprocket();
    }
  }, [UserselectedProduct, Useraddress]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(trackingId);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 3000);
  };
  console.log('address',Useraddress)
  console.log('selected Product',UserselectedProduct)
  return (
    <>
   <Navbar/>
   <div className="min-h-screen bg-gradient-to-br from-gray-400 to-gray-600 flex items-center justify-center py-10">
   <div className="max-w-xl w-full bg-white shadow-xl rounded-lg p-8 space-y-6 my-20">
          {errorMessage && (
          <div className="bg-red-500 text-white p-2 rounded-md">
            {errorMessage}
          </div>
        )}
        <AiOutlineCheckCircle className="text-green-500 text-6xl mx-auto" />
        <h1 className="text-4xl font-bold text-gray-800">Order Successful!</h1>
        <p className="text-lg text-gray-600">Thank you </p>
                
        <div className="bg-gray-50 p-4 rounded-lg shadow-md space-y-2">
          <h2 className="text-xl font-semibold text-gray-800">
            Product Details
          </h2>
          <p className="text-gray-600">
            <span className="font-medium">Name:</span> {UserselectedProduct.name}
          </p>
          <p className="text-gray-600">
            <span className="font-medium">Price:</span> ${UserselectedProduct.price}
          </p>
        </div>

                
                 
        <div className="bg-gray-50 p-4 rounded-lg shadow-md space-y-2">
          <h2 className="text-xl font-semibold text-gray-800">
            Shipping Address
          </h2>
          <p className="text-gray-600">{Useraddress.street}</p>
          <p className="text-gray-600">
            {Useraddress.city}, {Useraddress.state} {Useraddress.pincode}
          </p>
        </div>
              
            
    
        <div className="space-y-2">
          <p className="text-gray-600">
            <span className="font-medium">Tracking ID:</span>{" "}
            {trackingId || "Fetching..."}
          </p>
    
    
          <div className="flex justify-center gap-4">
          <button
            onClick={copyToClipboard}
            className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 flex items-center gap-2"
          >
            <AiOutlineCopy className="text-lg" />
            Copy Tracking ID
          </button>

          <a
            href={`https://www.shiprocket.in/shipment-tracking`}
            target="_blank"
            rel="noopener noreferrer"
            className={`bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 flex items-center gap-2 ${
              !trackingId ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            <TbTruckDelivery className="text-lg" />
            Track Order
          </a>
        </div>
    
        {copySuccess && (
          <p className="text-green-500">Tracking ID copied to clipboard!</p>
        )}

        <Link
         to='/catalogue'
          className=" text-blue-900 px-6 my-3 rounded-md cursor-pointer" >
          Order More
        </Link>
           </div>
         </div>
        </div>
        </>
      );
      
}

 